"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _BaseValidator2 = _interopRequireDefault(require("./BaseValidator"));

var _Patterns = _interopRequireDefault(require("../Patterns"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var UserBypassValidator =
/*#__PURE__*/
function (_BaseValidator) {
  _inherits(UserBypassValidator, _BaseValidator);

  function UserBypassValidator() {
    var _this;

    var mkto = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "legacy";
    var hvhtCheck = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    _classCallCheck(this, UserBypassValidator);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(UserBypassValidator).call(this, "UserBypass", mkto));
    _this.hvhtCheck = hvhtCheck;
    var required = mkto === "legacy" ? ["company", "mainPhone"] : ["Company_Self_Reported__c", "phone"];
    _this.required = ["country", "lastName", "leadStatus", "postalCode"].concat(required, _toConsumableArray(_this.required));
    _this.props = {
      "leadStatus": {
        "type": "string",
        "enum": ["B"],
        "error": "'leadStatus' must be 'B' for lead type '".concat(_this.type, "'.")
      },
      "InteractionStage": {
        "oneOf": [{
          "type": "string",
          enum: ["2"]
        }, {
          "type": "integer",
          enum: [2]
        }],
        "error": "'InteractionStage' must be '2' for lead type '".concat(_this.type, "'.")
      }
    };

    if (Boolean(_this.hvhtCheck)) {
      _this.required = ["ctx_bypass_approved"].concat(_toConsumableArray(_this.required));
      _this.props = _objectSpread({}, _this.props, {
        "ctx_bypass_approved": {
          "type": "string",
          "pattern": _Patterns.default.TRUE,
          "error": 'SystemBypass & UserBypass records must be approved (submitted ${/ctx_bypass_approved}).'
        }
      });
    }

    _this._init();

    return _this;
  }

  return UserBypassValidator;
}(_BaseValidator2.default);

exports.default = UserBypassValidator;
//# sourceMappingURL=UserBypassValidator.js.map